import { useDispatch, useSelector } from "react-redux";
import { PatientClinicalCountsType } from "DataTypes/Redux";
import { setClinicalCounts } from "Redux/Patient/Action";
import RedoxApi from "Service/Redox.api";

/**
 * The patient's clinical record counts (medications, allergies, ...), shared
 * through the store so every sidebar modal reads the one response.
 *
 * The patient screen loads them on open and after each EHR sync. A section
 * only has to call refreshCounts itself after its own add, edit or delete.
 */
const useClinicalCounts: () => {
  counts: PatientClinicalCountsType | null;
  refreshCounts: (patientId?: string | number | null) => Promise<void>;
} = () => {
  const dispatch = useDispatch();
  const counts: PatientClinicalCountsType | null = useSelector(
    (state: any) => state?.patient?.clinicalCounts || null
  );
  const storePatientId: string | null = useSelector(
    (state: any) => state?.patient?.patientInfo?.id || null
  );

  // The id is passed in by the patient screen, which asks before patientInfo
  // has reached the store; everywhere else the stored patient is the one.
  const refreshCounts: (
    patientId?: string | number | null
  ) => Promise<void> = async (patientId) => {
    const id = patientId || storePatientId;
    if (!id) return;
    const res = await RedoxApi.ClinicalCountsSearch({ id1: id });
    // A failure keeps whatever is already shown rather than blanking it.
    if (res?.success && res?.data) dispatch(setClinicalCounts(res.data));
  };

  return { counts, refreshCounts };
};

export default useClinicalCounts;
